<div [ngClass]="{'pe-alert':true,'pe-no-margin':item.data.fullWidth}"
     [ngStyle]="{
             maxWidth:layoutSetting.maxWidth + 'px'}">
  <app-sub-component-container [layoutSetting]="layoutSetting" [item]="item">

    <div class="pe-a-description">
      {{item.data.description}}
    </div>
  </app-sub-component-container>

</div>
